import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  recommendationsHeading: {
    id: 'RecommendationsPanel.recommendationsHeading',
    defaultMessage: 'Recommendations for you',
    description: 'Personalize courses heading on recommendations panel',
  },
  popularCoursesHeading: {
    id: 'RecommendationsPanel.popularCoursesHeading',
    defaultMessage: 'Popular courses',
    description: 'Popular courses heading on recommendations panel',
  },
  exploreCoursesButton: {
    id: 'RecommendationsPanel.exploreCoursesButton',
    defaultMessage: 'Explore courses',
    description: 'Button to explore more courses on recommendations panel',
  },
});

export default messages;
